var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"ll-form-callback\">\n	<div class=\"ll-form-callback__content\">\n		<button class=\"ll-form-callback__close\">\n		</button>\n\n		<span class=\"ll-form-callback__icon icon-heart\"></span>\n		<h2 class=\"ll-form-callback__title\">\n			Obrigado por participar!\n		</h2>\n		<p>\n			Sua doação foi concluída com sucesso. Você receberá um email com detalhes da transação.\n		</p>\n	</div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/form/form-callback.hbs
// module id = 48
// module chunks = 0